<h1 mat-dialog-title>{{item.id ? '' : 'Új'}} Tulajdonság</h1>
<div mat-dialog-content>
  <app-select-search [isDisabled]="data.isEdit" label="Tulajdonság" [list]="options" [model]="item.attribute" (modelChanged)="item.attribute = $event;onAttributeChange($event);" [isRequired]="true"></app-select-search>
  <mat-form-field class="w-100 mb-2">
    <mat-label>Érték</mat-label>
    @if (!config || !config.options) {
      <input matInput type="text" placeholder="Érték" name="value" [maxLength]="config && config.length ? config.length : 1000" [(ngModel)]="item.value" required>
    }
    @if (config && config.options) {
      <mat-select [(ngModel)]="item.value">
        @for (o of config.options; track o) {
          <mat-option [value]="o.id">
            {{o.name}}
          </mat-option>
        }
      </mat-select>
    }
    @if (config && config.length) {
      <mat-hint>Character limit is: {{config.length}}</mat-hint>
    }
  </mat-form-field>

  <mat-form-field class="w-100">
    <mat-label>Kezdete</mat-label>
    <input  matInput #sdInput [matDatepicker]="sdPicker" (focus)="sdPicker.open()" name="start_date" [(ngModel)]="item.start" (dateChange)="onDateChange('start')">
    <mat-datepicker-toggle matSuffix [for]="sdPicker"></mat-datepicker-toggle>
    <mat-datepicker #sdPicker (closed)="sdInput.blur()"></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="w-100">
    <mat-label>Vége</mat-label>
    <input  matInput #edInput [matDatepicker]="edPicker" (focus)="edPicker.open()" name="end_date" [(ngModel)]="item.end" (dateChange)="onDateChange('end')">
    <mat-datepicker-toggle matSuffix [for]="edPicker"></mat-datepicker-toggle>
    <mat-datepicker #edPicker (closed)="edInput.blur()"></mat-datepicker>
  </mat-form-field>
</div>
<div mat-dialog-actions align="end">
  <!--<button *ngIf="data.item && data.item.id" mat-button (click)="onConfirmDelete()" color="warn" >Delete</button>-->
  <button mat-button (click)="onNoClick()">Bezár</button>
  <button mat-button color="primary" (click)="onSaveClick()" translate>SAVE</button>
</div>
